/**
 * Slideshow carousel fix script
 * This properly initializes the slideshow slider and ensures navigation works correctly
 */
$(document).ready(function() {
  // Wait for page to fully load
  setTimeout(function() {
    // Find all slideshows
    var slideshows = $('.js-slideshow-v1');
    
    if (slideshows.length) {
      slideshows.each(function() {
        var slideshow = $(this);
        
        // Unslick if already initialized
        if (slideshow.hasClass('slick-initialized')) {
          slideshow.slick('unslick');
        }
        
        // Re-initialize with all the proper settings
        slideshow.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 4000,
          speed: 800,
          dots: true,
          arrows: true,
          prevArrow: '<button type="button" class="prev-slide"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 490.787 490.787"><path d="M362.671 490.787a10.663 10.663 0 01-7.552-3.115L120.452 253.006c-4.164-4.165-4.164-10.917 0-15.083L355.119 3.256c4.093-4.237 10.845-4.354 15.083-.262 4.237 4.093 4.354 10.845.262 15.083l-.262.262-227.025 227.115 227.136 227.115c4.171 4.16 4.179 10.914.019 15.085a10.67 10.67 0 01-7.661 3.133z"/></svg></button>',
          nextArrow: '<button type="button" class="next-slide"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 490.8 490.8"><path d="M135.685 3.128c-4.237-4.093-10.99-3.975-15.083.262-3.992 4.134-3.992 10.687 0 14.82l227.115 227.136L120.581 472.461c-4.237 4.093-4.354 10.845-.262 15.083 4.093 4.237 10.845 4.354 15.083.262l.262-.262 234.667-234.667c4.164-4.165 4.164-10.917 0-15.083L135.685 3.128z"/></svg></button>',
          fade: true,
          infinite: true,
          cssEase: 'linear',
          responsive: [
            {
              breakpoint: 768,
              settings: {
                arrows: true,
                dots: true
              }
            }
          ]
        });
        
        // Force proper styles for arrows and navigation
        $('.section-slideshow-v1 .slick-arrow').css({
          'z-index': '10',
          'opacity': '1',
          'visibility': 'visible',
          'display': 'block',
          'cursor': 'pointer',
          'position': 'absolute'
        });
        
        $('.section-slideshow-v1 .prev-slide').css({
          'left': '20px'
        });
        
        $('.section-slideshow-v1 .next-slide').css({
          'right': '20px'
        });
        
        $('.section-slideshow-v1 .slick-dots').css({
          'z-index': '10',
          'opacity': '1',
          'visibility': 'visible',
          'display': 'block',
          'position': 'absolute',
          'bottom': '20px'
        });
        
        // Ensure images are visible
        $('.section-slideshow-v1 .picture-slideshow img').css({
          'opacity': '1',
          'visibility': 'visible'
        });
        
        // Add specific click handlers for navigation
        $('.section-slideshow-v1 .prev-slide').off('click').on('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          slideshow.slick('slickPrev');
        });
        
        $('.section-slideshow-v1 .next-slide').off('click').on('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          slideshow.slick('slickNext');
        });
      });
      
      console.log('All slideshows initialized successfully');
    }
  }, 1000);
});
